module.exports = __webpack_public_path__ + "static/media/UnLockWithCircleIcon.f7d105f5.svg";